import { z } from "zod";

/**
 * Metadata for a single HubSpot deal property. Consumed by the frontend to
 * build grouped dropdowns when mapping custom fields.
 */
export const HubSpotDealPropertyMetadataSchema = z.object({
  name: z.string(),
  label: z.string(),
  type: z.string(),
  fieldType: z.string(),
  groupName: z.string(),
});
export type HubSpotDealPropertyMetadata = z.infer<
  typeof HubSpotDealPropertyMetadataSchema
>;
